import { useContext, useEffect, useState } from "react";
import { StyleContext } from "../../providers/StyleContextProvider";
import { getQuizResults } from "../../services/RecruiterService";
import { LoggedRecruiter } from "../../models/LoggedRecruiter";
import { AuthContext } from "../../providers/AuthContextProvider";
import useErrorPage from "../../hooks/useErrorPage";
import { JobQuizResultModel } from "../../models/JobQuizResultModel";
import { ReactComponent as PlusIcon } from '../../assets/svg/plus.svg';
import { ReactComponent as MinusIcon } from '../../assets/svg/minus.svg';
import { ApplicationPopUpLoader } from "../Loaders/ApplicationPopUpLoader";

interface CandidateQuizResults {
    quizResults: JobQuizResultModel[];
    interviewDate: string;
}

interface Props {
    jobApplicationId: number;
}

export const QuizTab: React.FC<Props> = (props) => {
    const styleContext = useContext(StyleContext);
    const tabStyles = styleContext.getComponentStyle("applicationStatusTabs");  
    const styles = tabStyles.quizTab;      
    const authContext = useContext(AuthContext);  
    const recruiter: LoggedRecruiter | null = authContext.getLoggedRecruiter();    
    const [quizData, setQuizData] = useState<CandidateQuizResults | null>(null);
    const [expandedQuizzes, setExpandedQuizzes] = useState<Set<number>>(new Set());
    const [loading, setLoading] = useState<boolean>(false);
    const [toErrorPage] = useErrorPage();

    useEffect(() => {
        quizResults(props.jobApplicationId);
    }, []);

    const toggleQuiz = (quizId: number) => {
        setExpandedQuizzes(prev => {
            const newSet = new Set(prev);
            if (newSet.has(quizId)) {
                newSet.delete(quizId);
            } else {
                newSet.add(quizId);
            }
            return newSet;
        });
    };

    async function quizResults(jobApplicationId: number) {    
        setLoading(true);
        await getQuizResults(jobApplicationId, recruiter!.recruiterId, recruiter!.token)
        .then((response: CandidateQuizResults) => {
            setQuizData(response);
            setLoading(false);
        })
        .catch((error) => {            
            toErrorPage(error);
        });
    }

    return (
        <>
            <div style={styles.rowWrapper}>
                <div style={styles.title}>Quiz</div>
            </div>
            {loading ? <ApplicationPopUpLoader/> : <div style={styles.quizWrapper}>
                {quizData && quizData.quizResults.length > 0 && (
                    <>
                        {quizData.quizResults.map((quiz, quizIndex) => {
                            const isExpanded = expandedQuizzes.has(quiz.jobQuizId);
                            return (
                                <div key={quiz.jobQuizId} style={styles.quizContainer}>
                                    <div style={styles.quiz} onClick={() => toggleQuiz(quiz.jobQuizId)}>
                                        {isExpanded ? <MinusIcon style={styles.quiz.icon}/> : <PlusIcon style={styles.quiz.icon}/>}
                                        <div style={styles.quiz.quizDetailsWrapper}>
                                            <div style={styles.quiz.quizName}>{quiz.quizName}</div>
                                            <div style={styles.quiz.quizDetails}>Duration: {quiz.time}, {quiz.status} (Score-{quiz.score})</div>
                                        </div>
                                    </div>
                                    {isExpanded && 
                                    <div style={styles.quizContent}>
                                        {quiz.candidateAnswers.map((answer, answerIndex) => (
                                            <div style={styles.question}>
                                                <div style={styles.questionNumber}>{"Question " + (answerIndex + 1).toString().padStart(2, '0')}</div>
                                                <div style={styles.question.row}>
                                                    <div style={styles.question.text} dangerouslySetInnerHTML={{ __html: answer.jobQuestion.question}}>
                                                    </div>
                                                </div>
                                                <div style={styles.answerWrapper}>
                                                    <div style={styles.answerWrapper.text}>{"Answer"}</div>
                                                    <div style={{
                                                            ...styles.answerWrapper.answers,
                                                            ...(answer.score === 0) && styles.answerWrapper.answers.red,
                                                            ...(answer.score === 100) && styles.answerWrapper.answers.green
                                                        }}
                                                    >
                                                        {answer.candidateAnswer}
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>}
                                </div>
                            )
                        })}
                    </>
                )}
            </div>}
        </>
    )
}